let jQuery = {};
export { jQuery as default };
export const inject = (jQueryNew) => {
    jQuery = jQueryNew;
}